import script from "./addUser.vue?vue&type=script&setup=true&lang=js"
export * from "./addUser.vue?vue&type=script&setup=true&lang=js"

import "./addUser.vue?vue&type=style&index=0&id=62178fe5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62178fe5"]])

export default __exports__